const industryExperienceJson = {
    infor: {
        "title": '行业经验',
    },
    serviceList: {
        "title": '行业洞察 创意设计 技术创新',
        "content": {
            "title": '行业经验',
            "list": [{
                "id": 1,
                "image": './images/industry-experience/list1.png',
                "mobImages": './images/industry-experience/mob/list1.png',
                "title": '金融行业',
                "texts": [{
                        "id": 1,
                        "str": '如何在科技进步的大背景下，采用设计驱动，使金融服务得到跨越式发展，使客户体验得到显著提升？'
                    }, {
                        "id": 2,
                        "str": '喜得基于多年金融行业咨询与设计经验，在业务创新、智慧银行设计与实施、数字化交互设计等多个方面，帮助金融行业客户打造创新而不失稳重的完美客户体验！'
                    }

                ],
            }, {
                "id": 2,
                "image": './images/industry-experience/list2.png',
                "mobImages": './images/industry-experience/mob/list2.png',
                "title": '文体娱乐',
                "texts": [{
                        "id": 1,
                        "str": '体育赛事或大型文化娱乐空间都是综合性的服务平台，聚集民众的兴趣与热情，也是主办方、主营方与第三方服务商协力为客户打造创新服务的好机会。'
                    }, {
                        "id": 2,
                        "str": '运用Design Thinking，为其服务体系进行创新设计，喜得将使活动或赛事耳目一新，眼前一亮！'
                    }

                ],
            }, {
                "id": 3,
                "image": './images/industry-experience/list3.png',
                "mobImages": './images/industry-experience/mob/list3.png',
                "title": '互联网+',
                "texts": [{
                        "id": 1,
                        "str": '互联网或移动互联网深深改变了各行各业的运行规则。'
                    }, {
                        "id": 2,
                        "str": '光有直面客户，敢于变革的勇气还不够，还要有点石成金的魔法棒。'
                    }, {
                        "id": 3,
                        "str": '喜得基于丰富的行业经验，领先的创新理念，成熟的设计方法，为各行各业的客户插上"互联网+"飞翔的翅膀！'
                    }

                ],
            }, {
                "id": 4,
                "image": './images/industry-experience/list4.png',
                "mobImages": './images/industry-experience/mob/list4.png',
                "title": '信息通信',
                "texts": [{
                    "id": 1,
                    "str": '信息通信行业始终站在国际竞争的最前沿，如何保持高速高质量的发展？在科技驱动的同时，我们是否应该更多地从客户视角重新审视我们所提供的服务？'
                }, {
                    "id": 2,
                    "str": '基于多年的行业经验，喜得提出运用服务设计的创新理念，再造客户服务与互动体系，创造与众不同的客户体验！'
                }],
            }]
        },
    }
}

export default industryExperienceJson
